import { differenceInDays, endOfDay, startOfDay, subDays } from 'date-fns';

import { getTimeInSeconds } from './helpers';

// Lower bound for the dashboard's "All Time" range when the tenant has no
// onboarding/creation date to anchor to — either because the account request
// has not resolved yet or because the record predates those fields. It matches
// the earliest date the dashboard's custom range picker allows.
export const ALL_TIME_FALLBACK_START = '2023-01-02T00:00:00.000Z';

/**
 * The dashboard's "All Time" range: from when the tenant joined through now.
 * Safe to call with a missing/empty account — falls back to ALL_TIME_FALLBACK_START.
 */
export const getAllTimeRange = (account) => {
  const accountStartedAt = account?.onboardedAt || account?.createdAt;

  return {
    startDate: getTimeInSeconds(
      accountStartedAt ? new Date(accountStartedAt * 1000) : new Date(ALL_TIME_FALLBACK_START),
    ),
    endDate: getTimeInSeconds(new Date()),
  };
};

// 'All Time' has no period before it to measure against, so the dashboard clears
// the comparison dates instead of inventing a pre-onboarding window. The stats
// widgets treat missing comparison dates as "no comparison" and hide the trend.
export const NO_COMPARISON_RANGE = { comparisonStartDate: null, comparisonEndDate: null };

/**
 * The period of equal length immediately preceding the given range, used as the
 * default comparison window. Takes and returns epoch seconds.
 */
export const getPreviousPeriodRange = (startDate, endDate) => {
  const currentStart = startOfDay(new Date(startDate * 1000));
  const currentEnd = endOfDay(new Date(endDate * 1000));
  const periodDays = Math.abs(differenceInDays(currentStart, currentEnd)) + 1;

  const comparisonEndDate = getTimeInSeconds(endOfDay(subDays(currentStart, 1)));
  const comparisonStartDate = getTimeInSeconds(startOfDay(subDays(new Date(comparisonEndDate * 1000), periodDays - 1)));

  return { comparisonStartDate, comparisonEndDate };
};
